import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { AUTOMATION_QUERY_KEYS } from '../Automation/queryKeys';

interface MutationVariables {
	templateId: string;
	beforeId?: string;
	step: Api.HandwrittenCardAutomationStep;
	withEmailFallback: boolean;
	impersonationContext?: Api.IImpersonationContext;
}

export function useAutomationTemplateStepHwcCreateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.HandwrittenCardAutomationStep, variables: MutationVariables) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ templateId, step, beforeId, withEmailFallback, impersonationContext }: MutationVariables) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/HandwrittenCard`,
					queryParams: {
						beforeId,
						withEmailFallback,
					},
					impersonationContext,
				}),
				'POST',
				step
			);
		},
		onError,
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.template(variables.templateId) });
			onSuccess?.(data, variables);
		},
	});
}
